<template>
  <a-spin :spinning="loading" style="margin-left: -20px; margin-top: -20px; margin-bottom: -20px">
    <a-row>
      <a-col :lg="8" :md="24">
        <a-card :bordered="false">
          <a-alert type="info" :showIcon="true">
            <div slot="message">
              <span v-if="this.currSelected.title">{{ $t('disp.selected') + '：' }}</span>
              <span v-else>{{ $t('disp.clickTree') }}</span>
              <span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
              <a v-if="this.currSelected.title" style="margin-left: 10px" @click="onClearSelected">{{
                $t('disp.btn.cancel')
              }}</a>
            </div>
          </a-alert>

          <a-input-search
            @search="onSearch"
            style="width: 100%; margin-top: 10px"
            v-model="searchText"
            :placeholder="$t('disp.ph.input', [$t('disp.departName')])"
          />

          <!-- ツリー-->
          <a-col>
            <template>
              <a-dropdown :trigger="[this.dropTrigger]" @visibleChange="dropStatus">
                <span style="user-select: none">
                  <a-empty v-show="departTree.length == 0" style="padding: 55px"></a-empty>
                  <a-tree
                    v-show="departTree.length > 0"
                    checkable
                    multiple
                    draggable
                    @drop="onDrop"
                    @dragenter="onDragEnter"
                    @select="onSelect"
                    @check="onCheck"
                    @rightClick="rightHandle"
                    :selectedKeys="selectedKeys"
                    :checkedKeys="checkedKeys"
                    :treeData="departTree"
                    :checkStrictly="checkStrictly"
                    :expandedKeys="iExpandedKeys"
                    :autoExpandParent="autoExpandParent"
                    @expand="onExpand"
                  >
                    <span slot="hasSlot" slot-scope="{ title, orgType, key }">
                      <span
                        v-if="orgType == '1'"
                        style="font-size: 16px"
                        v-html="keywordsColorful(title, searchText)"
                      ></span>
                      <span style="font-size: 15px" v-html="keywordsColorful(title, searchText)" v-else></span>
                      <a-icon
                        v-if="key == selectedKeys"
                        type="arrow-left"
                        class="animate__animated animate__fadeInRight"
                        style="margin-left: 8px; color: var(--color-green)"
                      ></a-icon>
                    </span>
                  </a-tree>
                </span>
                <!--右クリックイベント、追加、削除機能を追加-->
                <a-menu slot="overlay" v-if="!this.executeDisabled">
                  <a-menu-item @click="handleAdd(3)" key="1">{{ $t('disp.btn.add') }}</a-menu-item>
                  <a-menu-item v-if="isLeaf" @click="handleDelete" key="2">{{ $t('disp.btn.delete') }}</a-menu-item>
                  <a-menu-item @click="closeDrop" key="3">{{ $t('disp.btn.cancel') }}</a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
          </a-col>
          <div class="tree-bootom-button">
            <a-dropdown :trigger="['click']" placement="topCenter">
              <a-menu slot="overlay">
                <a-menu-item key="1" @click="switchCheckStrictly(1)">{{ $t('disp.tree.relation') }}</a-menu-item>
                <a-menu-item key="2" @click="switchCheckStrictly(2)">{{ $t('disp.tree.cancelRelation') }}</a-menu-item>
                <a-menu-item key="3" @click="checkALL">{{ $t('disp.tree.checkALL') }}</a-menu-item>
                <a-menu-item key="4" @click="cancelCheckALL">{{ $t('disp.tree.cancelCheckALL') }}</a-menu-item>
                <a-menu-item key="5" @click="expandAll">{{ $t('disp.tree.expandAll') }}</a-menu-item>
                <a-menu-item key="6" @click="closeAll">{{ $t('disp.tree.closeAll') }}</a-menu-item>
              </a-menu>
              <a-button>
                {{ $t('disp.tree.operation') }}
                <a-icon type="up" />
              </a-button>
            </a-dropdown>
            <a-button icon="plus" v-if="departTree.length == 0" @click="handleAdd(1)">{{
              $t('disp.btn.add')
            }}</a-button>
            <a-button v-if="this.selectedKeys.length > 0 && !this.executeDisabled" @click="handleAdd(2)">{{
              $t('disp.btn.addChildDepart')
            }}</a-button>
            <a-button v-if="this.checkedKeys.length > 0 && !this.executeDisabled" @click="batchDel" type="default">{{
              $t('disp.btn.deleteBatch')
            }}</a-button>
          </div>
        </a-card>
      </a-col>
      <a-col :lg="16" :md="24">
        <a-tabs defaultActiveKey="1" style="padding-left: 30px">
          <a-tab-pane tab="组织信息" key="1">
            <a-empty v-show="!currSelected.key" :description="$t('msg.I_K0002002_01')" style="margin: 10% 0" />
            <div v-show="currSelected.key" style="width: 85%; margin: 10px 0px 17px">
              <DepartInfo
                ref="DepartInfo"
                @emit="loadTree(changePlanId)"
                :changePlanId="changePlanId"
                :executeDisabled="executeDisabled"
              ></DepartInfo>
            </div>
          </a-tab-pane>

          <a-tab-pane tab="所属员工" key="2" :forceRender="true">
            <DepartUserInfo
              ref="DepartUserInfo"
              :changePlanId="changePlanId"
              :executeDisabled="executeDisabled"
            ></DepartUserInfo>
          </a-tab-pane>
        </a-tabs>
      </a-col>

      <DepartModal ref="DepartModal" @emit="onSearch()" :changePlanId="changePlanId"></DepartModal>

      <ActionHistroy ref="ActionHistroy"></ActionHistroy>
    </a-row>
  </a-spin>
</template>
<script>
import { httpAction, deleteAction, getAction, putAction, postAction } from '@/api/manage'
import { tableMixin } from '@/mixins/tableMixin'
import DepartInfo from '@/views/k00/k0002/modules/DepartInfo'
import DepartModal from '@/views/k00/k0002/modules/DepartModal'
import DepartUserInfo from '@/views/k00/k0002/modules/DepartUserInfo'
import ActionHistroy from './modules/ActionHistroy'

export default {
  name: 'DepartAllChange',
  mixins: [tableMixin],
  components: {
    DepartInfo,
    DepartModal,
    DepartUserInfo,
    ActionHistroy,
  },
  data() {
    return {
      // 组织变更主键
      changePlanId: '',
      // 是否可以编辑
      executeDisabled: true,
      // 合併した後にプロパティを設定
      dropModel: {},
      // 新规セーブマーク
      addSaveFlag: false,
      // 展开指定的树节点
      iExpandedKeys: [],
      // 加载中状态
      loading: false,
      // 是否自动展开父节点
      autoExpandParent: true,
      // 组织筛选字段
      searchText: '',
      // 親組織数据源
      treeData: [],
      visible: false,
      // 左侧组织树数据源
      departTree: [],
      // 左侧组织树右键选择key
      rightClickSelectedKey: '',
      // 左侧组织树右键删除是否显示标记
      rightClickSelectedIsLeaf: false,
      // 触发下拉的行为
      dropTrigger: '',
      // 左侧组织树多选keys
      checkedKeys: [],
      // 左侧组织树选中key
      selectedKeys: [],
      // 记录撤销前选中的节点
      selectedRecord: {},
      // 选中节点key及title
      currSelected: {},
      // 左侧组织树所有keys
      allTreeKeys: [],
      // checkable 状态下节点选择完全受控（父子节点选中状态不再关联）
      checkStrictly: true,
      url: {
        delete: '/blaze-sys/k00/k0015/DepartAction/delete',
        deleteBatch: '/blaze-sys/k00/k0015/DepartAction/deleteBatch',
        searchByKeywords: '/blaze-sys/k00/k0015/DepartAction/searchBy',
        queryTreeActionList: '/blaze-sys/k00/k0015/DepartAction/queryTreeActionList',
        departActionCheck: '/blaze-sys/k00/k0015/DepartAction/departActionCheck',
        departAllChange: '/blaze-sys/k00/k0015/Action/departAllChange',
        departMarge: '/blaze-sys/k00/k0015/DepartAction/departMarge',
        departChangeChild: '/blaze-sys/k00/k0015/DepartAction/departChangeChild',
        actionRevoke: '/blaze-sys/k00/k0015/DepartAction/actionRevoke',
        getDepartAction: '/blaze-sys/k00/k0015/DepartAction/getDepartAction',
      },
    }
  },
  computed: {
    // 左侧组织树右键删除是否显示标记
    isLeaf: function () {
      return this.rightClickSelectedIsLeaf
    },
  },
  methods: {
    // データをロードする
    load(changePlanId, executeDisabled) {
      this.executeDisabled = executeDisabled
      this.loadTree(changePlanId)
    },
    //  右サイドのツリーをロードする
    loadTree(changePlanId) {
      this.changePlanId = changePlanId
      var that = this
      that.iExpandedKeys = []
      that.allTreeKeys = []
      that.treeData = []
      that.departTree = []
      getAction(this.url.queryTreeActionList, { changePlanId: changePlanId }).then((res) => {
        if (res.success) {
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[i]
            that.treeData.push(temp)
            that.departTree.push(temp)
            that.setThisExpandedKeys(temp)
            that.getAllKeys(temp)
          }
        }
      })
    },
    // ツリーをを開く
    setThisExpandedKeys(node) {
      if (node.children && node.children.length > 0) {
        this.iExpandedKeys.push(node.key)
        for (let a = 0; a < node.children.length; a++) {
          this.setThisExpandedKeys(node.children[a])
        }
      }
    },
    // 右クリック操作
    rightHandle(node) {
      this.dropTrigger = 'contextmenu'
      this.rightClickSelectedKey = node.node.eventKey
      this.rightClickSelectedIsLeaf =
        node.node.dataRef.parentId == '' || node.node.dataRef.parentId == null ? false : true
    },
    // 開く時間
    onExpand(expandedKeys) {
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.iExpandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    // ドロップダウンを右クリックチェンジイベント
    dropStatus(visible) {
      if (visible == false) {
        this.dropTrigger = ''
      }
    },
    // ドロップダウンを右クリックして閉じる
    closeDrop() {
      this.dropTrigger = ''
    },
    // 部門を一括削除
    batchDel: function () {
      if (this.checkedKeys.length <= 0) {
        this.$message.warning(this.$t('msg.I_K0002002_01'))
      } else {
        var ids = ''
        for (var a = 0; a < this.checkedKeys.length; a++) {
          ids += this.checkedKeys[a] + ','
        }
        var that = this
        this.$confirm({
          title: that.$t('disp.warn'),
          content: that.$t('msg.W_K0002002_03'),
          onOk: function () {
            if (that.loading) {
              return
            } else {
              // ローディング開始
              that.loading = true
            }

            postAction(that.url.deleteBatch, { ids: ids, changePlanId: that.changePlanId })
              .then((res) => {
                if (res.success) {
                  that.$message.success(that.$t(res.message))
                  that.onSearch()
                  that.onClearSelected()
                }
              })
              .finally(() => {
                that.loading = false
              })
          },
        })
      }
    },
    // 部門データを検索
    onSearch() {
      let that = this
      getAction(this.url.searchByKeywords, { keyWord: that.searchText, changePlanId: that.changePlanId }).then(
        (res) => {
          if (res.success) {
            that.iExpandedKeys = []
            that.allTreeKeys = []
            that.treeData = []
            that.departTree = []
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i]
              that.treeData.push(temp)
              that.departTree.push(temp)
              that.setThisExpandedKeys(temp)
              that.getAllKeys(temp)
            }
          }
        }
      )
      this.onClearSelected()
    },
    hide() {
      this.visible = false
    },
    // 左侧组织树点击复选框触发事件
    onCheck(checkedKeys, info) {
      // 親子チェックモードを切り替え
      if (this.checkStrictly) {
        this.checkedKeys = checkedKeys.checked
      } else {
        this.checkedKeys = checkedKeys
      }
    },
    // 左侧组织树点击树节点触发事件
    onSelect(selectedKeys, e) {
      let record = e.node.dataRef
      this.selectedRecord = record

      if (this.selectedKeys.includes(record.key)) {
        this.onClearSelected()
      } else {
        this.currSelected = Object.assign({}, record)
        this.selectedKeys = [record.key]

        this.$refs.DepartInfo.edit(this.currSelected)

        this.$refs.DepartUserInfo.queryParam.username = ''
        this.$refs.DepartUserInfo.onClearSelected()
        this.$refs.DepartUserInfo.open(record)
      }
    },
    // 撤销后，选中最近撤销的组织节点
    onRevokeSelect(record) {
      if (Object.keys(record).length != 0) {
        // 如果最近选中节点不为空，重新选择组织节点
        getAction(this.url.getDepartAction, { changePlanId: this.changePlanId, departId: record.id }).then((res) => {
          if (res.success) {
            record = Object.assign(record, res.result)

            this.currSelected = Object.assign({}, record)
            this.selectedKeys = [record.key]

            this.$refs.DepartInfo.edit(this.currSelected)

            this.$refs.DepartUserInfo.queryParam.username = ''
            this.$refs.DepartUserInfo.onClearSelected()
            this.$refs.DepartUserInfo.open(record)
          }
        })
      }
    },
    getCurrSelectedTitle() {
      return !this.currSelected.title ? '' : this.currSelected.title
    },
    // 清除中选状态
    onClearSelected() {
      this.checkedKeys = []
      this.currSelected = {}
      this.selectedKeys = []
      this.$refs.DepartUserInfo.currentDeptId = ''
      this.$refs.DepartUserInfo.parentId = ''
    },
    // 组织新增
    handleAdd(num) {
      if (num == 1) {
        this.$refs.DepartModal.add(null, 1)
        this.$refs.DepartModal.title = this.$t('disp.btn.add')
      } else if (num == 2) {
        let key = this.currSelected.key
        if (!key) {
          this.$message.warning(this.$t('msg.I_K0002002_01'))
          return false
        }
        this.$refs.DepartModal.add(this.selectedKeys, 2)
        this.$refs.DepartModal.title = this.$t('disp.btn.add')
      } else {
        this.$refs.DepartModal.add(this.rightClickSelectedKey, 2)
        this.$refs.DepartModal.title = this.$t('disp.btn.add')
      }
    },
    // 组织删除
    handleDelete() {
      var that = this
      this.$confirm({
        title: that.$t('disp.warn'),
        content: that.$t('msg.W_K0002002_04'),
        onOk: function () {
          if (that.loading) {
            return
          } else {
            // ローディング開始
            that.loading = true
          }

          postAction(that.url.delete, { id: that.rightClickSelectedKey, changePlanId: that.changePlanId })
            .then((res) => {
              if (res.success) {
                that.$message.success(that.$t('msg.delete.success'))
                that.onSearch()
                that.onClearSelected()
              }
            })
            .finally(() => {
              that.loading = false
            })
        },
      })
    },
    // <!---- author:os_chengtgen -- date:20190827 --  for:親子チェックモードを切り替え =======------>
    expandAll() {
      this.iExpandedKeys = this.allTreeKeys
      this.autoExpandParent = true
    },
    closeAll() {
      this.iExpandedKeys = []
    },
    checkALL() {
      this.checkStriccheckStrictlytly = false
      this.checkedKeys = this.allTreeKeys
    },
    cancelCheckALL() {
      this.checkedKeys = []
    },
    switchCheckStrictly(v) {
      if (v == 1) {
        this.checkStrictly = false
      } else if (v == 2) {
        this.checkStrictly = true
      }
    },
    getAllKeys(node) {
      if (!node.disableCheckbox) {
        this.allTreeKeys.push(node.key)
      }

      if (node.children && node.children.length > 0) {
        for (let a = 0; a < node.children.length; a++) {
          this.getAllKeys(node.children[a])
        }
      }
    },
    keywordsColorful(str, key) {
      var reg = new RegExp('(' + key + ')', 'g')
      var newStr = str.replace(reg, "<font style='background:#ff0;'>$1</font>")
      return newStr
    },
    // データを保存、Actionデータを有効に設定する
    handleOk(dataAction) {
      // 非同期ロードが効かない問題を処理
      return new Promise((resolve) => {
        let sysChangePlan = {}
        sysChangePlan = dataAction
        sysChangePlan.id = this.changePlanId
        httpAction(this.url.departAllChange, sysChangePlan, 'post').then((res) => {
          if (res.success) {
            this.$message.success(this.$t(res.message))
            this.addSaveFlag = true
            // 親コンポーネント使用して閉じる
            this.$emit('handleCancel')
          }
        })
        // loading
        resolve(true)
      })
    },
    // ノードをドラッグしてイベントに入る
    onDragEnter(info) {
      this.iExpandedKeys = info.expandedKeys
    },
    // ノードをドラッグイベント
    onDrop(info) {
      this.dropModel.beforeDepartKey = info.dragNode.eventKey
      this.dropModel.afterDepartKey = info.node.eventKey
      document.querySelector('#freemenu').style = 'left: ' + event.pageX + 'px; top: ' + event.pageY + 'px;'
    },
    // 合併
    handleMarge() {
      if (this.loading) {
        return
      } else {
        // ローディング開始
        this.loading = true
      }

      httpAction(
        this.url.departMarge,
        {
          changePlanId: this.changePlanId,
          beforeDepartKey: this.dropModel.beforeDepartKey,
          afterDepartKey: this.dropModel.afterDepartKey,
        },
        'put'
      )
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t(res.message))
            this.onSearch()
            this.onClearSelected()
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    //  サブ組織を追加
    handleChangeChild() {
      if (this.loading) {
        return
      } else {
        // ローディング開始
        this.loading = true
      }

      httpAction(
        this.url.departChangeChild,
        {
          changePlanId: this.changePlanId,
          beforeDepartKey: this.dropModel.beforeDepartKey,
          afterDepartKey: this.dropModel.afterDepartKey,
        },
        'put'
      )
        .then((res) => {
          if (res.success) {
            this.$message.success(this.$t(res.message))
            this.onSearch()
            this.onClearSelected()
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 取り消し
    handleRevoke() {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      httpAction(
        this.url.actionRevoke,
        {
          changePlanId: this.changePlanId,
        },
        'put'
      )
        .then((res) => {
          if (res.success) {
            if (res.message == 'msg.revoke.nodata') {
              this.$message.warning(this.$t(res.message))
            } else {
              this.$message.success(this.$t(res.message))
              this.onSearch()
              this.onRevokeSelect(this.selectedRecord)
            }
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 履历页面
    handleHistory() {
      this.$refs.ActionHistroy.open(this.changePlanId)
    },
  },
}
</script>
<style lang="less" scoped>
.ant-btn {
  margin-bottom: 5px;
}

.tree-bootom-button {
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding-top: 10px;
  text-align: left;
  left: 0;
  border-radius: 0 0 2px 2px;
  margin-bottom: -15px;
}

/deep/ .ant-tree-checkbox-disabled {
  display: none;
}

/deep/ .ant-spin-spinning {
  position: fixed !important;
}

.anticon-arrow-right {
  animation: fadeIn ease-in-out 1.2s infinite;
}

@keyframes fadeIn {
  0% {
    transform: translateX(0px);
    opacity: 1;
  }

  50% {
    transform: translateX(3px);
    opacity: 0.8;
  }

  100% {
    transform: translateX(0px);
    opacity: 1;
  }
}
</style>
